import BackHandIcon from '@mui/icons-material/BackHandOutlined';
import DraftIcon from '@mui/icons-material/DescriptionOutlined';
import CheckIcon from '@mui/icons-material/Check';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {
  MarketingCampaignWithSource,
  PocketflowsCampaignStatus,
} from '../../../types/marketing';
import Badge from '../../global/Badge';

const getStatusIcon = (status: PocketflowsCampaignStatus) => {
  const Icon =
    status === 'draft'
      ? DraftIcon
      : status === 'started' || status === 'finished'
      ? CheckIcon
      : status === 'scheduled'
      ? AccessTimeIcon
      : BackHandIcon;
  return Icon;
};

interface Props {
  campaign: MarketingCampaignWithSource;
}

function CampaignBadge({ campaign }: Props) {
  const { status } = campaign.source;
  const statusText = status.charAt(0).toUpperCase() + status.slice(1);

  return (
    <Badge
      colorScheme={
        status === 'draft'
          ? 'grey'
          : status === 'started' || status === 'finished'
          ? 'secondary'
          : status === 'scheduled'
          ? 'warning'
          : 'primary'
      }
      icon={getStatusIcon(status)}
      text={statusText}
      sx={{
        width: 'fit-content',
      }}
    />
  );
}

export default CampaignBadge;
